export default __webpack_public_path__ + "static/media/ray.00673382.jpg";